// stripe.js
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_KEY = process.env.REACT_APP_AUS_STRIPE_KEY;

// Stripe refuses live keys outside a secure context (https or localhost) and
// rejects the load promise, which crashes the dev overlay when the app is
// opened over plain http on a LAN IP (e.g. testing on a phone). Payments can't
// work there anyway, so skip loading; <Elements stripe={null}> is supported.
const isLiveKeyOnInsecurePage =
  String(STRIPE_KEY || "").startsWith("pk_live") &&
  typeof window !== "undefined" &&
  !window.isSecureContext;

export const stripePromise = isLiveKeyOnInsecurePage
  ? null
  : loadStripe(STRIPE_KEY);
